<template>
  <div
    ref="scrollable"
    class="dashboard-page-wrapper test-page dm-dl-test"
    tabindex="0"
    @keydown="handleKeyDown"
  >
    <div class="top-wrap">
      <div class="text-img">
        <h2>{{ isPvtTest ? 'Differential Liberation (AI Predicted)' : 'Differential Liberation' }}</h2>
        <div v-if="isPvtTest" class="test-pdf-div pvt-param-header-btn" @click="paramConfigOpen = true">
          <span>Parameters</span>
        </div>
        <div v-else class="test-header-actions">
          <div v-if="canOpenQaqc" class="test-pdf-div pvt-param-header-btn" @click="goToQaqcTest">
            <span>QA/QC</span>
          </div>
          <template v-if="receivedData">
            <div v-if="pdfLoader === true" class="test-pdf-div">
              <div class="img-content">
              <img :src="pdf_loader_image" alt="loader Image" />
              </div>
            </div>
            <div v-else-if="receivedData.testID !== ''" @click="goToPdf()" class="test-pdf-div">
              <div class="img-content">
              <img :src="pdf_icon" alt="pdf icon" />
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="top-content" v-if="receivedData">
        <v-img
          src="../../../assets/Images/Assets/top image.png"
          alt="test image"
          width="49px"
          height="49px"
        ></v-img>
        <div class="fields-info">
          <div class="fields-info-wrap">
            <div
              v-for="(item, index) in receivedData.headers.filter(
                h => !(h.key && h.key.endsWith('_UOM'))
              )"
              :key="index"
              class="field-item"
            >
              <p class="field-item-label">{{ item.displayName }}</p>
              <p class="test-top-values">
                <v-tooltip location="top" content-class="test-top-value-tooltip">
                  <template v-slot:activator="{ props }">
                    <span v-bind="props" class="value-text">
                      {{ formatHeaderValue(item) }}
                    </span>
                  </template>
                  <span>{{ item.value }}</span>
                </v-tooltip>
                <span
                  v-if="item.key && receivedData.headers.some(
                    h => h.key === item.key + '_UOM'
                  )"
                  class="uom"
                >
                  &nbsp;{{
                    receivedData.headers.find(
                      h => h.key === item.key + '_UOM'
                    ).value
                  }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="top-content" v-else>
        <test-loaders />
      </div>
    </div>
    <div class="tabs-data">
      <div class="tabs-toggle">
        <v-tabs v-model="tab">
          <v-tab value="one">Oil Properties</v-tab>
          <v-tab value="two">Gas Properties</v-tab>
          <v-tab v-if="!isPvtTest" value="three">Liberated Gas Compositions</v-tab>
          <v-tab v-if="!isPvtTest" value="four">Residual Oil Compositions</v-tab>
        </v-tabs>
       
        <v-btn-toggle v-if="!isPvtTest && tab === 'four'" v-model="toggleFractionParent" mandatory class="elevation-0 axis-toggle" @update:modelValue="handleToggleChange">
          <v-btn :value="true" class="switch-btn text-none text-caption">wt%</v-btn>
          <v-btn :value="false" class="switch-btn text-none text-caption">mol%</v-btn>
        </v-btn-toggle>
      </div>

      <v-card-text class="pa-0 pt-3">
        <v-window v-model="tab">
          <v-window-item value="one">
            <OilData @data-updated="handleDataUpdate" />
          </v-window-item>

          <v-window-item value="two">
            <GasData />
          </v-window-item>

          <v-window-item v-if="!isPvtTest" value="three">
            <GasCompData />
          </v-window-item>

          <v-window-item v-if="!isPvtTest" value="four">
            <OilCompData @data-updated="handleDataUpdate" @toggle-fraction="updateToggleFractionComp" ref="oilCompData" />
          </v-window-item>
        </v-window>
      </v-card-text>
    </div>
    <v-snackbar v-model="snackbarMessage" color="#E53535" timeout="3000" v-if="snackbarMessage != null">
      Error : {{ snackbarMessage }}
    </v-snackbar>
    <pvt-param-config-modal
      v-model="paramConfigOpen"
      experiment-type="dv"
      :sample-meta="pvtSampleMeta"
    />
    <!-- <Filters @drawerStateChanged="handleRightDrawerStateChange" /> -->
  </div>
</template>

<script>
import GasCompData from './GasCompData.vue';
import GasData from './Tables/GasData.vue';
import OilCompData from './Tables/OilCompData.vue';
import OilData from './Tables/OilData.vue';
import TestLoaders from '../Loaders/TestLoaders.vue';
import PvtParamConfigModal from '../Common/PvtParamConfigModal.vue';
import axios from "axios";
import { executeSampleReportDownload } from "../../../utils/sampleReportDownload";
import { getTenantPrefixFromRoute } from "@/utils/tenant";
import { formatMetaNumericValue } from "@/utils/cache";
import { isPvtTestRoute } from "@/utils/pvtTestRoute";
import { hasWriteQcPermission } from "@/utils/permissions";
import { buildQaqcUnifiedTestLocation } from "@/components/layout/QAQC/Overview/qaqcOverviewTab";
import Plotly from "plotly.js-dist-min";
export default {
  components: { OilData, GasData, GasCompData, OilCompData, TestLoaders, PvtParamConfigModal, },
  name: "DataTabs",
  computed: {
    isPvtTest() {
      return isPvtTestRoute(this.$route);
    },
    canOpenQaqc() {
      if (this.isPvtTest) return false;
      if (!hasWriteQcPermission(this.$store)) return false;
      return Boolean(this.$route.params.sampleId && this.$route.params.id);
    },
  },
  data: () => ({
    toggleFractionParent: true,
    tab: null,
    receivedData: null,
    assetName: "",
    fieldName: "",
    wellName: "",
    pdf_icon: require("../../../assets/Images/pdfIcon.svg"),
    pdf_loader_image: require("../../../assets/Images/pdfLoader.gif"),
    pdfLoader: false,
    snackbarMessage: null,
    paramConfigOpen: false,
    pvtSampleMeta: null,
  }),
  methods: {
    updateToggleFractionComp(value) {
      this.toggleFractionParent = value; // Update the parent state when child emits an event
    },
    handleToggleChange() {
        this.$refs.oilCompData.toggleFraction = this.toggleFractionParent; // Sync state with the child
        this.$refs.oilCompData.toggleFractionFunction(); // Call the child's 
    },
    formatHeaderValue(item) {
      return formatMetaNumericValue(item?.value, item?.digits);
    },
    handleDataUpdate(data) {
      if (data?.sampleMeta) {
        this.pvtSampleMeta = data.sampleMeta;
      }
      if (!this.receivedData?.headers?.length && data?.headers?.length) {
        this.receivedData = data;
      }
    },
    goToQaqcTest() {
      const sampleId = this.$route.params.sampleId || this.receivedData?.sampleID;
      const testId = this.$route.params.id || this.receivedData?.testID;
      const tenantPrefix = getTenantPrefixFromRoute(this.$route);
      if (!sampleId || !testId || !tenantPrefix) return;
      this.$router.push(
        buildQaqcUnifiedTestLocation({
          tenantPrefix,
          sampleId,
          testType: "dltest",
          testId,
          well: this.$route.params.well || this.wellName,
          fluidSampleID: this.receivedData?.fluidSampleID,
        })
      );
    },
    async goToPdf() {
      this.snackbarMessage = null;
      this.pdfLoader = true;
      try {
        const tenantId = getTenantPrefixFromRoute(this.$route) || "";
        const sampleId = this.$route.params.sampleId;
        const result = await executeSampleReportDownload({
          extension: "pdf",
          httpGet: () =>
            axios.get(
              process.env.VUE_APP_API_URL + `public/api/samples/${sampleId}/download`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                  "X-TenantID": tenantId,
                },
                responseType: "blob",
              }
            ),
        });
        if (!result.ok && !result.limitModal && result.snackbarMessage) {
          this.snackbarMessage = result.snackbarMessage;
        }
      } finally {
        this.pdfLoader = false;
      }
    },
    handleKeyDown(event) {
      const key = event.key;
      const tabs = this.isPvtTest ? ['one', 'two'] : ['one', 'two', 'three', 'four'];
      if (key === 'ArrowDown') {
        this.$refs.scrollable.scrollTop += 50;
      } else if (key === 'ArrowLeft') {
        const currentIndex = this.tab ? tabs.indexOf(this.tab) : 0;
        this.tab = currentIndex <= 0 ? tabs[tabs.length - 1] : tabs[currentIndex - 1];
      } else if (key === 'ArrowRight') {
        const currentIndex = this.tab ? tabs.indexOf(this.tab) : 0;
        this.tab = currentIndex === tabs.length - 1 ? tabs[0] : tabs[currentIndex + 1];
      }
    },
    resizeVisiblePlots() {
      const resize = () => {
        const root = this.$el;
        if (!root) return;
        root.querySelectorAll(".js-plotly-plot").forEach((el) => {
          try {
            Plotly.Plots.resize(el);
          } catch (error) {
            /* plot may not be ready yet */
          }
        });
      };
      this.$nextTick(() => {
        requestAnimationFrame(resize);
        setTimeout(resize, 200);
      });
    },
  },
  created() {
    if (this.isPvtTest) {
      this.toggleFractionParent = false;
    }
  },
  watch: {
    tab() {
      this.resizeVisiblePlots();
    },
  },
  mounted() {
    this.tab = 'one';
    this.assetName = this.$route.params.asset.replace(/-/g, ' ');
    this.fieldName = this.$route.params.field.replace(/-/g, ' ');
    this.wellName = this.$route.params.well;
    this.$refs.scrollable.focus();
    this.resizeVisiblePlots();
  },
}
</script>